import AboutPage from "@/components/About/AboutPage";

function AboutRoute() {
  return <AboutPage />;
}

export default AboutRoute;
